import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CopylinkComponent } from "../../sb-editor-tools/copylink/copylink.component";
import { FullscreenComponent } from "../../sb-editor-tools/fullscreen/fullscreen.component";
import { IndoorComponent } from "../../sb-editor-tools/indoor/indoor.component";
import { NavigationComponent } from "../../sb-editor-tools/navigation/navigation.component";
import { VrComponent } from "../../sb-editor-tools/vr/vr.component";
import { VersionComponent } from "./version/version.component";
import { PluginsComponent } from "./plugins.component";


@NgModule({
    declarations: [
        PluginsComponent,
        FullscreenComponent,
        CopylinkComponent,
        VrComponent,
        IndoorComponent,
        NavigationComponent,
        VersionComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [],
    exports:[
        PluginsComponent
    ]
})
export class PluginsModule {}